<section class="vector-db">
  <div class="cui-title-bar">
    <h1><span class="material-symbols-outlined">database</span> Vector DB</h1>
  </div>
  <article class="cui-card information-card">
    <header class="cui-card__header">
      <span class="material-symbols-outlined">info</span> General Information
    </header>
    <dl>
      <div>
        <dt>Status</dt>
      </div>
      <div>
        <dt>Progress</dt>
      </div>
      <div>
        <dt>Vectors</dt>
      </div>
      <div>
        <dt>Size</dt>
      </div>
      <div>
        <dt>Online since</dt>
      </div>
    </dl>
  </article>
  <div class="cui-action-bar">
    <button cuiButton variant="plain" type="button">
      <span class="material-symbols-outlined">arrow_upward_alt</span> Sort by name
    </button>
    <button cuiButton variant="plain" type="button">
      <span class="material-symbols-outlined">add</span> Add Data Source
    </button>
  </div>
  <div class="source-grid">
    @for (source of sources; track source) {
      <article class="cui-card source-card">
        <header class="cui-card__header">
          <span class="material-symbols-outlined">article</span><strong>{{ source }}</strong>
        </header>
        <div class="document-preview">
          <span class="material-symbols-outlined">description</span><span>Document preview</span>
        </div>
      </article>
    }
  </div>
</section>
